import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { UnassignedShift } from 'modules/shift_management/lib/types'

interface Props {
  unassignedShift: UnassignedShift
}

const ShiftTime = ({ unassignedShift }: Props) => {
  const startTime = unassignedShift.startTime
  const endTime = unassignedShift.endTime

  return (
    <Box flexDirection="row" alignItems="center" gap="s4" width="full">
      <Text.Normal size="100" weight="medium" color="grey800">
        {startTime} - {endTime}
      </Text.Normal>
      {unassignedShift.overnightShift && (
        <Text size="100" color="grey1000">
          {i18n.t('shift_management.plus_1_day_tag')}
        </Text>
      )}
    </Box>
  )
}

export default observer(ShiftTime)
